import decorateComponentWithProps from 'decorate-component-with-props';
import TextEditorEntityLink from '../text-editor-entity-link';

function strategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
}

export default function createLinkEntityDecorator({ theme, followLinks } = {}) {
  return {
    strategy,
    component: decorateComponentWithProps(TextEditorEntityLink, { theme, followLinks }),
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/decorators/create-link-entity-decorator.js